import "../../../shared/app-loading-dots/app-loading-dots.js";

export function renderClickableText(text, onClick) {
    const span = document.createElement("span");
    span.textContent = text;
    if (onClick) {
        span.className = "cell-link";
        span.addEventListener("click", (event) => { event.stopPropagation(); onClick(); });
    }
    return span;
}

export function renderWordBoxes(raw, onClick, isValid = () => true) {
    if (!raw.includes(";")) {
        const span = document.createElement("span");
        span.textContent = raw;
        if (onClick && isValid(raw)) {
            span.className = "wordBox clickable";
            span.addEventListener("click", (event) => { event.stopPropagation(); onClick(raw); });
        }
        return span;
    }

    const wrapper = document.createElement("div");
    wrapper.className = "wordWrapper";
    raw.split(";").map(s => s.trim()).filter(Boolean).forEach(p => {
        const span = document.createElement("span");
        const clickable = !!onClick && isValid(p);
        span.className = clickable ? "wordBox clickable" : "wordBox";
        span.textContent = p;
        if (clickable) span.addEventListener("click", (event) => { event.stopPropagation(); onClick(p); });
        wrapper.appendChild(span);
    });
    return wrapper;
}

export const tableDefaults = {
    data: [],
    index: "id",
    addRowPos: "top",
    layout: "fitColumns",
    renderVertical: "basic",
    movableColumns: true,
    placeholder: '<app-loading-dots></app-loading-dots>',
    columnDefaults: {
        widthGrow: 1,
        minWidth: 120,
        headerFilter: "list",
        headerFilterParams: { values: [] },
        formatter: (cell) => {
            const field = cell.getColumn().getField();
            const value = field?.endsWith("Id")
                ? (cell.getRow().getData()[field.replace(/Id$/, "Name")] ?? cell.getValue())
                : cell.getValue();
            if (!value) return "";

            return renderWordBoxes(String(value));
        },
        accessorDownload: (value, data, type, params, column) => {
            const field = column?.getField?.();
            if (!field?.endsWith("Id")) return value;
            return data[field.replace(/Id$/, "Name")] ?? value;
        },
        sorter: (a, b, aRow, bRow, column) => {
            const field = column?.getField?.();
            if (!field?.endsWith("Id")) return String(a ?? "").localeCompare(String(b ?? ""));
            const nameField = field.replace(/Id$/, "Name");
            return (aRow.getData()[nameField] ?? "").localeCompare(bRow.getData()[nameField] ?? "");
        },
    },
};
